import React, { useContext } from 'react';
import { LoginResponse } from '../../api/fusionApi';

export interface Store {
  state?: LoginResponse | undefined;
  setState?: any;
}
const store: Store = {
  state: undefined,
  setState: () => {},
};

const AuthContext = React.createContext(store);
AuthContext.displayName = 'Admin Auth Context';
export const useAuthContext = () => useContext(AuthContext);
export default AuthContext;
